export default "/assets/images/dust-png.e4d9f4e5901bc779.png";